module.exports = __webpack_public_path__ + "fonts/LatoLatin-Hairline.41ecd31.woff2";